import { errorHandler } from "./error.service";
import { http, URL } from "./http.service";
export const addTransaction = async (bussinessId, data) => {
  // const { bussinessUuid } = data;
  try {
    let resp = await http.post(`${URL}/cashbook/${bussinessId}/add`, data);
    return resp;
  } catch (error) {
    errorHandler(error);
  }
};
export const getAlltransaction = async (businessId, params = {}) => {
  try {
    const queryString = new URLSearchParams(params).toString();
    let resp = await http.get(
      `${URL}/cashbook/${businessId}/get-cashbook?${queryString}`
    );
    return resp;
  } catch (error) {
    errorHandler(error);
  }
};
export const updateCashbook = async (businessId, transactionId, data) => {
  try {
    let resp = await http.put(
      `${URL}/cashbook/${businessId}/${transactionId}`,
      data
    );
    return resp;
  } catch (error) {
    errorHandler(error);
  }
};
export const deleteCashBook = async (businessId, transactionId) => {
  try {
    let resp = await http.delete(
      `${URL}/cashbook/${businessId}/${transactionId}`
    );
    return resp;
  } catch (error) {
    errorHandler(error);
  }
};
